import React, { Component } from "react";
import { Card, CardImg, Button } from "reactstrap";
import { isIE } from 'react-device-detect'
import * as kurentoUtils from "kurento-utils";

import EndScreenshareConfirmationModal from "COMPONENTS/CommonComponents/Modal/Modal";
import BitRateTile from "COMPONENTS/CommonComponents/BitRate/BitRateTile";
import ScrollBar from "COMPONENTS/CommonComponents/ScrollBar/ScrollBar";
import ScreenMaskingContainer from "COMPONENTS/ScreenMasking/ScreenMaskingContainer"

import { wsocket } from "WEBSOCKET/wsocket";
import { getMessage } from "CONFIG/i18n";
import { socketMessage, webRtcMessageId, mediaType } from "WEBSOCKET/constants";
import { USER_ROLES, downloadableModules, COMPONENT_IN_FOCUS, RECORDING_METHOD, FULL_SCREEN_V2_ID, LANGUAGE } from "../../Utils/Constants";
import {
  getTurnServerOptionConfig, getFirstNamebyParticipantId,
  isLandscapeLayout,
  isDesktopView,
  isMobileView,
  isTabletPortrait,
  isTabletLandscape,
  getDeviceOS
} from "UTILS/Utility";
import { Modules, BANDWIDTH_CUSTOM, } from "UTILS/Constants";
import screenfull from 'screenfull';

import ic_plus from "ASSETS/Images/ic_zoom_in.svg";
import ic_plus_dark from "ASSETS/Images/ic_zoom_in_dark.svg";
import ic_minus from "ASSETS/Images/ic_zoom_out.svg";
import ic_minus_dark from "ASSETS/Images/ic_zoom_out_dark.svg";
import ic_screenshare_download from "ASSETS/Images/ic_download_white.svg";
import ic_minimize from "ASSETS/Images/video_menu/ic_full_screen_stop.svg";
import ic_fullscreen_pc from "ASSETS/Images/video_menu/ic_switch_full_screen_white.svg";
import ic_fullscreen_sp from "ASSETS/Images/video_menu/ic_switch_full_screen.svg";

import { headerAction, sessionActions } from "CONFIG/ActionFactory";

import "./ScreenShare.less";

const ZOOM = {
  DEFAULT: 1.0,
  PLUS: 0.2,
  MINUS: -0.2,
  MAX: 4.0,
  MIN: 0.4
};

export default class ScreenShare extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screenShareId: null,
      showButton: false,
      showEndScreenshareConfirmationModal:false,
      streaming: false,
      isFullScreen: false,
      isConfirming: this.isConfirmingJudge() ? true : false,
      zoom: 1.0,
      defaultSize: {width: 0, frameHeight: 0},
      isOverflow: false
    };
    this.constraints = {
      audio: false,
      video: true
    };
    this.waitScreenShareRtcPeer = 0;
    this.fullScreenChangeHandler = this.fullScreenChangeHandler.bind(this);
    this.needRemoveFullScreenChangeHandler = false;
    this.screenShareElement = React.createRef();
    this.setShareFrameDimensions = this.setShareFrameDimensions.bind(this);
    this.resizeToggleScreenSharingLayout = this.resizeToggleScreenSharingLayout.bind(this);
    this.setDefaultFrame = this.setDefaultFrame.bind(this);
  }

  isConfirmingJudge () {
    return this.props.isConfirmScreenShare && this.props.screenSharingParticipantId === this.props.currentParticipantUniqueId
  }

  getIdSuffix() {
    return this.props.inFullScreenV2Container ? FULL_SCREEN_V2_ID.SUFFIX : '';
  }

  fullScreenChangeHandler = () => {
    if(!screenfull.isFullscreen){
      this.setState({
        isFullScreen : false,
      });
      screenfull.off('change', this.fullScreenChangeHandler );
      this.needRemoveFullScreenChangeHandler = false;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(!this.props.isFullScreenV2 ){
      if (this.state.isFullScreen && !prevState.isFullScreen && screenfull.isEnabled){
        screenfull.on('change', this.fullScreenChangeHandler );
        this.needRemoveFullScreenChangeHandler = true;
      }
    }
    // screenshare should be closed while refreshing since user's presenter access is revoked on refresh
    if (this.props.presenterId !== prevProps.presenterId && this.props.presenterId !== this.props.uniqueId &&
      this.props.screenSharingParticipantId === this.props.uniqueId) {
      this.onClose();
    }

    if (this.props.latestUpdatedParticipant && this.props.uniqueId === this.props.presenterId) {
      const { uniqueId } = this.props.latestUpdatedParticipant;
      if (prevProps.admittedParticipants.length > this.props.admittedParticipants.length 
        && this.props.screenSharingParticipantId == uniqueId) {
        this.onClose();
      }
    }

    // when screenshare zoom in make it zoom out when co-browse or snapshot started 
    if(!this.props.isZoomOut && 
      ((this.props.showSnapshot !== prevProps.showSnapshot && this.props.showSnapshot) ||
    (this.props.showCustomerCoBrowse !== prevProps.showCustomerCoBrowse && this.props.showCustomerCoBrowse) ||
    (this.props.snapshotPermissionReply !== prevProps.snapshotPermissionReply &&
      this.props.snapshotPermissionReply && this.props.uniqueId === this.props.snapshoteeId))) {
      this.toggleScreenSharingState();
    }
    
    if ((this.shouldShowZoomIcon() || isMobileView(this.props.orientation)) && prevProps.componentInFocus === COMPONENT_IN_FOCUS.CANVAS &&
      this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO) {
      this.props.setComponentInFocus(COMPONENT_IN_FOCUS.AUDIO_VIDEO);
      this.props.setValue("isZoomOut", true);
      this.setState({ zoom: ZOOM.DEFAULT })
    }

    if (prevProps.componentInFocus == COMPONENT_IN_FOCUS.AUDIO_VIDEO && this.props.componentInFocus == COMPONENT_IN_FOCUS.CANVAS) {
      this.toggleScreenSharingLayout();
    }

    if (prevProps.isZoomOut !== this.props.isZoomOut && !this.props.isZoomOut && this.props.isViewScreenShare) {
      this.setShareFrameDimensions(ZOOM.DEFAULT);
    }

    if(this.props.recordingMethod === RECORDING_METHOD.MANUAL
      && this.props.screenSharingParticipantId === this.props.uniqueId
      && this.props.isRecording !== prevProps.isRecording
    ){
      this.sendRecrdingWebsocketMessage(this.props.isRecording);
    }

    if (this.props.runScreenShare && prevProps.runScreenShare !== this.props.runScreenShare) {
      this.invokeGetDisplayMedia();
      headerAction.setRunScreenShare(!this.props.runScreenShare);
    }

    if (prevProps.isScreenMasking !== this.props.isScreenMasking) {
      this.resizeScreenMasking();
    }

    if(!this.props.inFullScreenV2Container) {
      const videoElement = document.getElementById(this.props.screenShareId);
      if ( videoElement ) {
        if ( this.props.isFullScreenV2 && !prevProps.isFullScreenV2 ) {
          videoElement.pause();
          console.log(`screen share has been paused successfully screenShareId=${this.props.screenShareId}`);
        } else if ( !this.props.isFullScreenV2 && prevProps.isFullScreenV2 ) {
          videoElement.play()
          .then(() => 
            console.log(`screen share has been played successfully screenShareId=${this.props.screenShareId}`))
          .catch((error) => 
            console.log(`an error occured while playing screen share, error : ${error && error.message ? error.message : JSON.stringify(error)}`));
          this.resizeScreenMasking();
          this.toggleScreenSharingLayout();
          this.setState({ zoom: ZOOM.DEFAULT })
          this.setShareFrameDimensions(ZOOM.DEFAULT);
        }
      }
    }

    if(prevProps.isZoomOut !== this.props.isZoomOut && isTabletLandscape(this.props.orientation)){
      this.toggleScreenSharingLayout();
      this.setShareFrameDimensions(ZOOM.DEFAULT);
    }

    if(prevProps.isHideBar !== this.props.isHideBar || prevState.isFullScreen !== this.state.isFullScreen|| prevProps.isFullScreenV2 && !this.props.isFullScreenV2){
      this.setZoomIconPosition();
    }

    if(prevProps.isScreenMasking && !this.props.isScreenMasking){
      this.resizeScreenMasking(true);
    }
  }

  playVideoInFullScreenV2Container = () => {
    const video = document.getElementById(this.props.screenShareId);
    video.srcObject = wsocket.screenShareRtcPeer.getRemoteStream();
    video.play()
    .then(() => 
      console.log(`screen share  has been played successfully.`))
    .catch((error) => 
      console.log(`an error occurred while playing screen share, error : ${error && error.message ? error.message : JSON.stringify(error)}`));
  }

  componentDidMount() {
    if (!wsocket.io) return;
    if (this.props.inFullScreenV2Container) {
      if ( this.props.screenSharingParticipantId !== this.props.currentParticipantUniqueId &&
        !this.props.isPeerError() ) {
        if( wsocket.screenShareRtcPeer && 
          wsocket.screenShareRtcPeer.peerConnection &&
          wsocket.screenShareRtcPeer.peerConnection.connectionState == "connected" ) {
          this.playVideoInFullScreenV2Container();
          this.setShareFrameDimensions();
        } else {
          this.waitScreenShareRtcPeer = setInterval( () => {
            if (this.props.isPeerError()) {
              clearInterval(this.waitScreenShareRtcPeer);
              this.waitScreenShareRtcPeer = 0;
              return;
            }
            if ( wsocket.screenShareRtcPeer && 
              wsocket.screenShareRtcPeer.peerConnection &&
              wsocket.screenShareRtcPeer.peerConnection.connectionState == "connected" ) {
              clearInterval(this.waitScreenShareRtcPeer);
              this.playVideoInFullScreenV2Container();
              this.setShareFrameDimensions();
              this.waitScreenShareRtcPeer = 0;
            }
          }, 500);
        }
      }
      return;
    }
    window.addEventListener("resize", this.resizeToggleScreenSharingLayout);
    if (
      this.props.screenSharingParticipantId ===
      this.props.currentParticipantUniqueId
    ) {
      console.log("ScreenShare-- Send");
      var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("safari") != -1) {
        if (ua.indexOf("chrome") > -1) {
          // Chrome
          this.invokeGetDisplayMedia();
        } else {
          // Safari
          this.setState({
            showButton: true
          });
        }
      } else {
        this.invokeGetDisplayMedia();
      }
    } else {
      console.log("ScreenShare-- Receive");
      this.invokeReceiveScreenShareMedia();
    }

    if(this.props.isConfirmScreenShare || this.props.presenterId !== this.props.uniqueId) {
      headerAction.updateHeaderIconClass(Modules.SCREENSHARE, "moduleIconActive cursorDisabled", " cursorDisabled");
    } else {
      headerAction.updateHeaderIconClass(Modules.SCREENSHARE, "moduleIconActive cursorDisabled", " cursorPointer");
    }
    let mediaElement = document.getElementById(this.props.screenShareId);
    // scroll to screen share video when screen share
    if(!isIE && (isMobileView(this.props.orientation))) {
      mediaElement.oncanplay = () => {
        this.setState({
          streaming: true
        });
        let screenShareDiv = document.getElementById("screenShareDiv");
        screenShareDiv && screenShareDiv.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      }
    } else if (isMobileView(this.props.orientation)) {
      this.interval = setInterval(()=> {
        let screenShareDiv = document.getElementById("screenShareDiv");
        if(document.getElementById(this.props.screenShareId) 
        && document.getElementById(this.props.screenShareId).videoWidth) {
          this.setState({
            streaming: true
          });
          screenShareDiv && screenShareDiv.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
          });
          clearInterval(this.interval)
        }
      }, 2000)
    } else {
      mediaElement.oncanplay = () => {
        this.setState({
          streaming: true
        });
      }
      let videoElement = document.getElementById(this.props.screenShareId);
      // isIE ? videoElement.width = "100%" : null
      if(videoElement) {
        let videoWidth = videoElement.offsetWidth;
        console.log('videoObject.offsetHeight: ', videoElement.offsetHeight);
        console.log('videoObject.offsetWidth: ', videoElement.offsetWidth);
        isIE ? videoElement.width = videoWidth: null
        isIE ? videoElement.height = videoWidth * 0.5625 : null
      }
    }

    if (this.shouldShowZoomIcon()) {
      this.props.setComponentInFocus(COMPONENT_IN_FOCUS.CANVAS);
      this.toggleScreenSharingLayout(false);
    }

    this.resizeScreenMasking();
    let screenShareVideo = document.getElementById("screenshare");
    if (screenShareVideo) {
      screenShareVideo.addEventListener("resize", this.handleResizeScreenMasking);
    }

    if (!this.props.inFullScreenV2Container && this.props.isFullScreenV2 && this.props.putFullScreenV2Target ) {
      this.props.putFullScreenV2Target();
    }

    if (this.props.componentInFocus !== COMPONENT_IN_FOCUS.CANVAS && isMobileView(this.props.orientation)) {
      this.props.setComponentInFocus(COMPONENT_IN_FOCUS.CANVAS);
    }

    isMobileView(this.props.orientation) && this.props.toggleHideBar(true);
    this.setZoomIconPosition();
    this.addPinchOperationControl();
    if (this.props.isViewScreenShare || this.props.screenSharingParticipantId !== this.props.currentParticipantUniqueId){
      this.setShareFrameDimensions();
    }

    window.addEventListener("resize", this.setDefaultFrame);

    const zoomButtons = document.getElementById("screenShareZoomButtons");
    if(zoomButtons){
      zoomButtons.addEventListener('dblclick', this.doubleClickZoomControl);
    }
  }

  componentWillUnmount() {
    if (!wsocket.io) return;
    if (this.props.inFullScreenV2Container) {
      if ( 0 != this.waitScreenShareRtcPeer ) {
        clearInterval(this.waitScreenShareRtcPeer);
      }
      return;
    }
    if(this.needRemoveFullScreenChangeHandler) {
      screenfull.off('change', this.fullScreenChangeHandler );
    }
    clearInterval(this.interval)
    headerAction.updateHeaderIconClass(Modules.SCREENSHARE, "moduleIcon", " cursorPointer");

    window.removeEventListener("resize", this.resizeToggleScreenSharingLayout);
    let screenShareVideo = document.getElementById("screenshare");
    if (screenShareVideo) {
      screenShareVideo.removeEventListener("resize", this.handleResizeScreenMasking);
    }

    this.props.setValue("isZoomOut", false);
    if(this.props.showAudioVideoComponent){
      this.props.setComponentInFocus(COMPONENT_IN_FOCUS.AUDIO_VIDEO);
    }

    this.removePinchOperationControl();
    const zoomButtons = document.getElementById("screenShareZoomButtons");
    if(zoomButtons){
      zoomButtons.removeEventListener('dblclick', this.doubleClickZoomControl);
    }

    window.removeEventListener("resize", this.setDefaultFrame);

  }

  doubleClickZoomControl(e) {
    e.preventDefault();
  }

  resizeToggleScreenSharingLayout(){
    this.toggleScreenSharingLayout(true);
  }

  setDefaultFrame() {
    this.setState({ zoom: ZOOM.DEFAULT }, () => this.setShareFrameDimensions(undefined, true));
    this.setZoomIconPosition();
    this.resizeScreenMasking();
  }
  
  handleResizeScreenMasking = () => {
    this.resizeScreenMasking();
  };
  
  addPinchOperationControl() {
    document.addEventListener("touchstart", this.preventTouchStart, { passive: false });
    document.addEventListener("touchmove", this.preventTouchStart, { passive: false });
    if(isMobileView(this.props.orientation) || isTabletLandscape(this.props.orientation)){
      document.body.classList.add("overscroll-none");
      document.documentElement.classList.add("overscroll-none");
    }
  }
  
  removePinchOperationControl() {
    document.removeEventListener("touchstart", this.preventTouchStart, { passive: false });
    document.removeEventListener("touchmove", this.preventTouchStart, { passive: false });
    if(document.body.classList.contains("overscroll-none")) { 
      document.body.classList.remove("overscroll-none");
    }
    if(document.documentElement.classList.contains("overscroll-none")) { 
      document.documentElement.classList.remove("overscroll-none");
    }
  }

  preventTouchStart(e) {
    if (e.touches.length > 1) {
      e.preventDefault();
    }
  }

  invokeReceiveScreenShareMedia = () => {
    let video = document.getElementById(this.props.screenShareId);
    
    let options = {
      remoteVideo: video,
      mediaConstraints: this.constraints,
      onicecandidate: this.onIceCandidate,
      configuration: {
        iceServers: getTurnServerOptionConfig(this.props.turnServer),
        iceTransportPolicy: window._env_.REACT_APP_ICE_TRANSPORT_POLICY || 'all'
      }
    };
    let self = this;
    this.props.clearPeerError();
    wsocket.screenShareRtcPeer = new kurentoUtils.WebRtcPeer.WebRtcPeerRecvonly(
      options,
      function(error) {
        if (error) {
          self.props.putPeerError(error);
          return console.error(error);
        }
        this.generateOffer(self.offerToReceiveVideo);
        self.setState({
          showBitRate: true
        })
      }
    );

    let pc = wsocket.screenShareRtcPeer.peerConnection; 

    pc.ontrack = (event) => {
      console.log("WEBRTC screenshare remote stream id for", 
        getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
        this.props.screenSharingParticipantId,
        event.track.id    
      );
    }

    pc.onconnectionstatechange = (event) => {
      console.log("SCREEN_SHARE", "WEBRTC receive only RTCPeerConnection state for", 
        getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
        this.props.screenShareId, pc.connectionState, pc.getTransceivers());
      switch(pc.connectionState) {
        case "connected": 
        case "completed":
          this.props.setValue("screen", wsocket.screenShareRtcPeer.getRemoteStream());
          if(isIE) {
            attachMediaStream(video, wsocket.screenShareRtcPeer.getRemoteStream());
          } else {
            video.srcObject = wsocket.screenShareRtcPeer.getRemoteStream();
          }
          if(!this.props.inFullScreenV2Container) {
            if( !this.props.isFullScreenV2) {
              video.play();
            } else {
              video.pause();
            }
          }
          break;
        case "disconnected":
        case "failed":
        case "closed":
          console.error("SCREEN_SHARE", "WEBRTC receive only RTCPeerConnection state for", 
            getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
            this.props.screenShareId, pc.connectionState, pc.getTransceivers());
          break;
      }
    }
    pc.oniceconnectionstatechange = ev => {
      console.log("SCREEN_SHARE", "WEBRTC receive only IceConnection state for", 
        getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
        this.props.screenShareId, pc.iceConnectionState);
      switch(pc.iceConnectionState) {
        case "disconnected":
        case "failed":
        case "closed":
          console.error("SCREEN_SHARE", "WEBRTC receive only IceConnection state for", 
            getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
            this.props.screenShareId, pc.iceConnectionState);
          break;
      }
    }

  };

  invokeGetDisplayMedia = () => {
    var videoConstraints = {
      aspectRatio: 1.777,
      height: this.props.screenshareBandwidthSettings.bandwidth? 
        this.props.screenshareBandwidthSettings.bandwidth !== BANDWIDTH_CUSTOM ?
          this.props.screenshareBandwidthSettings.bandwidth : this.props.screenshareCustomBandwidthSettings.size
        :
        null,
      frameRate: this.props.screenshareBandwidthSettings.fps,
    }
    let ssConstarints = {
      video: videoConstraints
    };
    if (!this.props.isScreenShare) {
      if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
        navigator.mediaDevices
        .getDisplayMedia(ssConstarints)
        .then(this.success)
        .catch(this.error);
      } else if (navigator.getDisplayMedia) {
        navigator
        .getDisplayMedia(ssConstarints)
        .then(this.success)
        .catch(this.error);
      } else if (
        typeof AdapterJS !== "undefined" &&
        AdapterJS.webrtcDetectedBrowser === "IE" &&
        AdapterJS.webrtcDetectedVersion >= 9
      ) {
        videoConstraints = this.props.screenshareBandwidthSettings.bandwidth? {
          mediaSource: ["screen"],
          aspectRatio: 1.777,
          height : {exact: this.props.screenshareBandwidthSettings.bandwidth},
          frameRate: this.props.screenshareBandwidthSettings.fps
        } :  {
          mediaSource: ["screen"],
          aspectRatio: 1.777,
          frameRate: this.props.screenshareBandwidthSettings.fps
        }

        navigator.getUserMedia(
          {
            audio: false,
            video: videoConstraints
          },
          this.success,
          this.error
        );
      } else {
        this.error("No suitable API to get Display Media");
      }
    } else {
      navigator.mediaDevices
      .getDisplayMedia(ssConstarints)
      .then((stream) => {
        const videoTrack = stream.getVideoTracks()[0];
        let pc = wsocket.screenShareRtcPeer.peerConnection;
        const sender = pc.getSenders().find(function (s) {
          return s.track.kind == videoTrack.kind;
        });
        this.props.screen.getTracks().forEach(track => track.stop());
        videoTrack.onended = () => {
          this.stopScreenShare();
        };
        sender.replaceTrack(videoTrack);
        let ssVideo = document.getElementById(this.props.screenShareId);
        ssVideo.srcObject = stream;
        this.props.setValue("screen", stream);
      })
    }
  };

  stopMediaTracksOfGivenStream = (stream) => {
    stream && stream.getTracks().forEach(track => {
      track.stop();
    });
    let ssVideo = document.getElementById(this.props.screenShareId);
    if(ssVideo){
      ssVideo.srcObject = null;
    }
  }

  success = screen => {
    let ssVideo = document.getElementById(this.props.screenShareId);
    var isIE = /*@cc_on!@*/ false || !!document.documentMode;
    if (isIE) {
      ssVideo = attachMediaStream(ssVideo, screen);
    } else {
      ssVideo.srcObject = screen;
    }
    screen.getVideoTracks()[0].onended = () => {
      this.stopScreenShare();
    };
    this.props.setValue("screen", screen);
    if(!this.state.isConfirming) {
      this.sendScreen();
    }
  };

  sendScreen = () => {
    const screen = this.props.screen;
    let options = {
      videoStream: screen,
      mediaConstraints: this.constraints,
      onicecandidate: this.onIceCandidate,
      configuration: {
        iceServers: getTurnServerOptionConfig(this.props.turnServer),
        iceTransportPolicy: window._env_.REACT_APP_ICE_TRANSPORT_POLICY || 'all'
      }
    };
    let self = this;
    wsocket.screenShareRtcPeer = new kurentoUtils.WebRtcPeer.WebRtcPeerSendonly(
      options,
      function(error) {
        if (error) {
          return console.error(error);
        }
        console.log("WEBRTC Screen share self stream id for", 
          getFirstNamebyParticipantId(self.props.admittedParticipants, self.props.uniqueId, true), 
          self.props.uniqueId,
          screen.id    
        );
        this.generateOffer(self.offerToReceiveVideo);
        self.setState({
          showBitRate: true
        })
      }
    );

    let pc = wsocket.screenShareRtcPeer.peerConnection; 

    pc.onconnectionstatechange = (event) => {
      console.log("SCREEN_SHARE", "WEBRTC send only RTCPeerConnection state for", 
        getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
        this.props.uniqueId, pc.connectionState, pc.getTransceivers());
      switch(pc.connectionState) {
        case "disconnected":
        case "failed":
        case "closed":
          console.error("SCREEN_SHARE", "WEBRTC send only RTCPeerConnection state for", 
            getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
            this.props.uniqueId, pc.connectionState, pc.getTransceivers());
          break;
      }
    }
    pc.oniceconnectionstatechange =ev=> {
      console.log("SCREEN_SHARE", "WEBRTC send only IceConnection state for", 
        getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
        this.props.uniqueId, pc.iceConnectionState);
      switch(pc.iceConnectionState) {
        case "disconnected":
        case "failed":
        case "closed":
          console.error("SCREEN_SHARE", "WEBRTC send only IceConnection state for", 
            getFirstNamebyParticipantId(this.props.admittedParticipants, this.props.screenSharingParticipantId, true), 
            this.props.uniqueId, pc.iceConnectionState);
          break;
      }
    }
    this.props.setValue("isScreenShare", true);
  };

  onIceCandidate = (candidate, wp) => {
    let message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.ICE_CANDIDATE,
        sessionKey: this.props.sessionKey,
        iceData: {
          candidate: candidate,
          senderId: this.props.screenSharingParticipantId,
          media: mediaType.SCREEN
        },
        isSnapshot: false
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  offerToReceiveVideo = (error, offerSdp, wp) => {
    if (error) return console.error("sdp offer error");
    var message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.SDP_OFFER,
        sessionKey: this.props.sessionKey,
        sdp: offerSdp,
        senderId: this.props.screenSharingParticipantId,
        media: mediaType.SCREEN,
        isSnapshot: false
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  stopScreenShare = () => {
    let message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.STOP_SCREEN_SHARING,
        sessionKey: this.props.sessionKey,
        media: mediaType.SCREEN
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
    this.stopMediaTracksOfGivenStream(this.props.screen);
    this.props.setValue("isScreenShare", false);
    this.props.setValue("isZoomOut", false);
  };

  error = e => {
    console.log("Screenshare" + e);
    this.stopScreenShare();
  };

  toggleScreenZoomout = () => {
    this.setState({
      isFullScreen : false,
      zoom:ZOOM.DEFAULT
    })
    screenfull.exit();
    this.resizeScreenMasking();
    this.setShareFrameDimensions(ZOOM.DEFAULT, isMobileView(this.props.orientation) && true);
  }
  
  toggleScreenZoomin = async () => {
    if( await this.props.handleFullScreenV2(this) ) {
      return;
    }

    let fullScreenDiv = document.getElementById("fullScreenDiv");
    fullScreenDiv.style.overflow = "hidden"; //#2 feedback vertical scroll
    screenfull.request(fullScreenDiv, { navigationUI: 'hide' });
    this.resizeScreenMasking();
    this.setShareFrameDimensions(ZOOM.DEFAULT);
    
    this.setState({
      isFullScreen : true,
      zoom:ZOOM.DEFAULT
    })
  }

  toggleScreenSharingState = () => {
    if(this.props.isZoomOut == true) {
      this.props.setComponentInFocus(COMPONENT_IN_FOCUS.CANVAS);
    }
    this.props.setValue("isZoomOut", !this.props.isZoomOut);
    this.setState({ zoom: ZOOM.DEFAULT });
  }

  toggleScreenSharingLayout = (onResize=false) => {
    if(!onResize && !this.props.isZoomOut) {
      window.scrollTo(0, 0);
    }
    let ssDiv = document.getElementById("cardBody" + this.getIdSuffix());
    let dashboardMain = document.getElementsByClassName("dashboardMain");
    const dashboardPadding = 8;
    const header = document.getElementById("commonHeader");
    let videoElement = document.getElementById(this.props.screenShareId)
    if(!ssDiv || !dashboardMain[0] || !header){
      return // issue comes up when we close screen share window
    }
    let whitboardposition = dashboardMain[0].getBoundingClientRect();
    // if (ssDiv.hasAttribute("style")) {
    //   ssDiv.removeAttribute("style");
    // } else {
    //   ssDiv.style.position = "fixed";
    //   ssDiv.style.width = "75%"; //TODO: Calculate
    //   ssDiv.style.top = "5em";
    //   ssDiv.style.left = "0.5em";
    // }

    if(isMobileView(this.props.orientation)){
      ssDiv.className = "cardBody displayFlex ssDiv1";
      ssDiv.style.width = "100%";
      ssDiv.style.height = "100%";
    }else{
      if (isIE) {
        ssDiv.className = "cardBody ssDiv2 cardBodyIE alignItemsCenter";
        ssDiv.style.width = dashboardMain[0].clientWidth + 'px';
        ssDiv.style.height = dashboardMain[0].clientHeight + "px";
        ssDiv.style.top = dashboardMain[0].offsetTop + 'px';
        if (videoElement) {
          videoElement.style.width = "85%";
          videoElement.style.height = "75%";
          videoElement.style.display = (this.props.screenSharingParticipantId === this.props.currentParticipantUniqueId && !this.props.isViewScreenShare)
            ? "none"
            : "block";
          videoElement.className = "screenShareVideo horizontalCenter";
        }
      } else {
        ssDiv.className = "cardBody ssDiv2 alignItemsCenter";
        if (isLandscapeLayout(this.props.isLandscape)) {
          // let parentElementposition = parentElement ? parentElement.getBoundingClientRect() : {};
          ssDiv.style.width = whitboardposition.width + "px";
          ssDiv.style.height = document.body.clientHeight - header.clientHeight - dashboardPadding + "px";
          if (videoElement) {
            if (this.props.screenSharingParticipantId !== this.props.uniqueId)
              //ssDiv.style.maxHeight = videoElement.clientHeight+200+"px";    
              videoElement.style.display = (this.props.screenSharingParticipantId === this.props.currentParticipantUniqueId && !this.props.isViewScreenShare)
                ? "none"
                : "block";
          }
        }
      }
    }
  };

  download = () => {
    this.props.broadcastDownloadAction(downloadableModules.SCREENSHARE);
    var video = document.getElementById(this.props.screenShareId);
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");
    canvas.height = video.clientHeight;
    canvas.width = video.clientWidth;

    if (
      typeof AdapterJS !== "undefined" &&
      AdapterJS.webrtcDetectedBrowser === "IE" &&
      AdapterJS.webrtcDetectedVersion >= 9
    ) {
      const lastFrame = video.getFrame();
      const image = new Image();
      image.onload = () => {
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        var blob = canvas.msToBlob();
        window.navigator.msSaveBlob(blob, 'dicomimage.png');
      };
      image.onerror = () => {
        console.error("Error Occured");
      }
      if(lastFrame) {
        image.setAttribute("src", "data:image/png;base64," + lastFrame);
      }
    }
    else{
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      let url = canvas.toDataURL();
      let downloadElement = document.getElementById("screenShareDownload");
      downloadElement.href = url;
      downloadElement.download = "screen_share.png";
    }
  };

  onClose = () => {
    this.stopScreenShare();
  };

  onOpenCloseEndScreenshareConfirmationModal = (modalState) => {
    this.setState({
      showEndScreenshareConfirmationModal: modalState
    })
  }

  shouldShowZoomIcon = () => {
    return isLandscapeLayout(this.props.isLandscape)
      && !(this.props.showSnapshot || (this.props.snapshoteeId && this.props.snapshotPermissionReply))
      && !this.props.showCustomerCoBrowse
  }

  renderRecordingMessage = () => {
    if (!this.props.isRecording || !this.props.videoRecordingMessage
      || this.props.screenSharingParticipantId !== this.props.currentParticipantUniqueId) {
      return;
    }
    return(
      <label className="recordingMassage">
        {this.props.videoRecordingMessage}
      </label>
    )
  }

  sendRecrdingWebsocketMessage = (isStart) => {
    let action = "";
    if (isStart) {
      action = webRtcMessageId.START_RECORDING;
    } else {
      action = webRtcMessageId.STOP_RECORDING;
    }
    const message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: action,
        sessionKey: this.props.sessionKey,
        media: mediaType.SCREEN,
        recordingTarget: this.props.recordingTarget,
      }
    };
    this.props.sendWebsocketMessage(
      socketMessage.events.MESSAGE,
      message
    );
  }

  resizeScreenMasking = (reset) => {
    let screenMaskingDiv = document.querySelector("#screenShareDiv .screenMaskingDiv");
    let fullScreenDiv = document.querySelector('#screenShareDiv .fullScreenDiv');
    const maskMsg = document.getElementsByClassName("presenterMsgDiv");
    const screenShare = document.getElementById("screenshare");

    if(reset){
      if(screenShare){
        screenShare.style.top = 0;
      }
      return;
    }
    
    if (screenMaskingDiv) {
      if (this.props.isScreenMasking) {
        if (fullScreenDiv) {
          screenMaskingDiv.style.height = fullScreenDiv.offsetHeight + 2 + 'px';
        }
        if(maskMsg && screenShare && this.props.presenterId === this.props.uniqueId) {
          screenShare.style.top = maskMsg[0].offsetHeight + 'px';
        }
      } else {
        screenMaskingDiv.style.height = '0px';
      }
    }
    if (wsocket.screenShareRtcPeer) {
      let senders = wsocket.screenShareRtcPeer.peerConnection.getSenders();
      if (senders && senders.length) {
        let sender = senders[0];
        if (sender.track) {
          sender.track.enabled = !this.props.isScreenMasking;
        }
      }
    }
  }

  screenShareConfirm = () => {
    const wasScreenMasking = this.props.isScreenMasking;
    
    this.setState({
      isConfirming: false
    })
    this.sendScreen();
    
    // Toggle screen masking off/on if it was enabled
    if (wasScreenMasking) {
      this.sendMaskingState(false);
      setTimeout(() => this.sendMaskingState(true), 100);
    }
  }

  sendMaskingState = (enabled) => {
    headerAction.setIsScreenMasking(enabled);
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.SET_IS_SCREEN_MASKING,
        sessionKey: this.props.sessionKey,
        screenMaskingEnable: enabled
      }
    });
  }
  
  selectOtherScreen = () => {
    this.stopMediaTracksOfGivenStream(this.props.screen);
    if (this.props.screenSharingParticipantId) {
      headerAction.setRunScreenShare(!this.props.runScreenShare);
    } 
  }
  
  cancelScreenShare = () => {
    this.onClose();
  }

  shareFrameTransform = (zoom) => {
    if (((this.state.zoom) < ZOOM.MIN && zoom !== ZOOM.PLUS) || ((this.state.zoom) > ZOOM.MAX && zoom !== ZOOM.MINUS)) {
      return;
    }

    this.setState({ zoom: this.state.zoom + zoom }, () => {
      this.setShareFrameDimensions(this.state.zoom);
    });
  }

  setInitialDisplay = (screenShare, screenShareFrame) => {
    const landscape = screenShare.videoWidth > screenShare.videoHeight;
    const isOverflowWidth = screenShare.videoWidth > screenShareFrame.clientWidth;
    let newSize = "";
    newSize = { ...this.state.defaultSize, width: screenShare.videoWidth };
    screenShare.style.width = isOverflowWidth || landscape && (isDesktopView(this.props.orientation) || this.props.isFullScreenV2) ? "100%" : "auto";

    // initialize height 
    screenShare.style.height = "auto";
    const portrait = screenShare.videoWidth < screenShare.videoHeight;
    const isOverflowHeight = screenShare.clientHeight > screenShareFrame.clientHeight;
    // resize height
    screenShare.style.height = isOverflowHeight || (portrait && (isDesktopView(this.props.orientation)|| isTabletPortrait(this.props.orientation))) || this.props.isFullScreenV2 ? "100%" : "auto";

    screenShare.style.top = "0%";
    screenShare.style.left = "50%";
    screenShare.style.transform = `translate(-50%) scale(1.0)`;
    screenShare.style.transformOrigin = "50% 0%";
    
    newSize = { ...newSize, frameHeight: screenShareFrame.clientHeight };
    this.setState({ defaultSize: newSize });
  }
  
  setShareFrameDimensions = (_zoom, resetFrame) => {
    const zoom = _zoom ? _zoom : this.state.zoom;
    const screenShare = document.getElementById(this.props.screenShareId);
    const screenShareFrame = document.getElementById("fullScreenDiv" + this.getIdSuffix());
    const screenShareHeading = document.getElementById("heading");
    const cardBody = document.getElementById("cardBody" + this.getIdSuffix());
    let isOverflowWidth = "";
    let newSize = "";

    if (!screenShare || !screenShareFrame || !screenShareHeading || !cardBody) {
      return;
    }
    
    if(!this.state.isFullScreen && !this.props.isFullScreenV2 && !this.props.isZoomOut){
      const frameHeight = cardBody.clientHeight - (isMobileView(this.props.orientation) ? 0 : screenShareHeading.clientHeight);
      screenShareFrame.style.height = frameHeight + "px";
    }

    if (_zoom == undefined){
      // initial display
      screenShare.addEventListener("loadedmetadata", () => {
        // Wait until the video width is retrievable
        if (screenShare.readyState >= 2) {
          this.setInitialDisplay(screenShare, screenShareFrame);
        }
      });

      // Initial display after rotation
      if (resetFrame) {
        this.setInitialDisplay(screenShare, screenShareFrame);
      }

      console.log(true,"initial");
    } else {
      // after zoom in or zoom out,
      isOverflowWidth = this.state.defaultSize.width * zoom > screenShareFrame.clientWidth;

      screenShareFrame.style.overflow = zoom > 1 ? "auto" : "hidden";
      this.setState({isOverflow: zoom > 1});
      // set screenShareFrame width for zoom area bug on Safari browser
      screenShareFrame.style.width = "";
      if(zoom > 1){
        setTimeout(()=>{
          screenShareFrame.style.width = "100%";
        },30)
      }
      screenShare.style.left = isOverflowWidth && !this.state.isFullScreen && !resetFrame ? "0%" : "50%";
      screenShare.style.top = this.state.isFullScreen ? "50%" : "0%";
      screenShare.style.transform = this.state.isFullScreen
        ? `translate(-50%,-50%) scale(${zoom})`
        : isOverflowWidth && !resetFrame
          ? `translate(0%) scale(${zoom})`
          : `translate(-50%, 0%) scale(${zoom})`;
      screenShare.style.transformOrigin = isOverflowWidth ? "0% 0%" : "50% 0%";

      newSize = { ...this.state.defaultSize, width: screenShare.clientWidth}
      this.setState({ defaultSize: newSize })

      console.log(false,"zoom");
    }
  }

  setZoomIconPosition = () => {
    const mobileBottomAreaToggleBtn = document.getElementById("mobileBottomAreaToggleBtn");
    const mobileBottomArea = document.getElementById("mobileBottomArea");
    const zoomButtons = document.getElementById("screenShareZoomButtons");
    const padding = 8;

    if (mobileBottomAreaToggleBtn !== null && mobileBottomArea !== null && zoomButtons !== null && isMobileView(this.props.orientation) && !this.state.isFullScreen) {
      let position = mobileBottomAreaToggleBtn.offsetHeight + 12; // 12 is "bottom" value of .mobileBottomAreaToggleBtn
      if (!this.props.isHideBar) {
        position = mobileBottomArea.offsetHeight;
      }
      zoomButtons.style.bottom = position + padding + "px";
    }
  }

  render() {
    const showMaskDiv = ( ( !this.props.isFullScreenV2 && !this.props.inFullScreenV2Container ) || this.props.inFullScreenV2Container ) ? true : false;
    const isHideScreen = this.props.screenSharingParticipantId === this.props.currentParticipantUniqueId &&
      !this.props.isViewScreenShare &&
      !this.props.isZoomOut &&
      !this.state.showButton;

    return (
      <div id={"screenShareDiv" + this.getIdSuffix()} className="screenShareDiv">
        {this.state.showEndScreenshareConfirmationModal ? (
          <EndScreenshareConfirmationModal
            show={true}
            isDoubleButton={true}
            handleNoClick={() => { this.onOpenCloseEndScreenshareConfirmationModal(false) }}
            handleYesClick={() => {
              this.onClose();
            }}
            message={getMessage("END_SCREENSHARE_CONFIRMATION_TEXT")}
          />
        ) : null}
        <Card
          className="cardBody displayFlex ssDiv1" id={"cardBody" + this.getIdSuffix()}
          onClick={() => {
            this.state.streaming && this.props.isZoomOut && isDesktopView(this.props.orientation) && 
            this.toggleScreenSharingState();
          }}
        >
          {!this.state.isFullScreen &&
            !this.props.isFullScreenV2 &&
            <div className={`heading ${(this.state.isConfirming && !this.state.showButton || isDesktopView(this.props.orientation)) ? "position-relative" : "position-absolute"}`} id="heading">
              <div className="leftHeadingConfirm" style={{ width: this.state.isConfirming ? "100%" : "auto" }}>
                {this.state.isConfirming && !this.state.showButton &&
                  <>
                    <div className={`confirmFlexContainer ${this.props.language == LANGUAGE.EN.name && "en-font"}`}>
                      <span className="screenShareBtn confirmMsg">
                        {getMessage("SCREENSHARE_CONFIRM")}
                      </span>
                      <Button
                        className="screenShareBtn confirmBtn"
                        onClick={() => this.screenShareConfirm()}
                      >
                        {getMessage("SCREENSHARE_SELECT_START")}
                      </Button>
                    </div>
                    <div className="confirmFlexContainer">
                      <Button
                        className="screenShareBtn otherWindowBtn"
                        onClick={() => this.selectOtherScreen()}
                      >
                        {getMessage("SCREENSHARE_SELECT_CHANGE")}
                      </Button>
                      <Button
                        className="screenShareBtn shareCancelBtn"
                        onClick={() => this.cancelScreenShare()}
                      >
                        {getMessage("SCREENSHARE_SELECT_CANCEL")}
                      </Button>
                    </div>
                  </>}
              </div>
              {<div className="rightHeading d-flex flex-row-reverse">
                {!this.state.isConfirming && this.props.screenSharingParticipantId ===
                    this.props.currentParticipantUniqueId &&
                    !this.props.isZoomOut &&
                    <Button
                      className="screenShareBtn endSessionBtn"
                      aria-label="Cancel"
                      onClick={() => this.onOpenCloseEndScreenshareConfirmationModal(true)}
                      title={getMessage("STOP_SCREEN_SHARE")}
                    >
                      {getMessage("STOP_SCREEN_SHARE")}
                    </Button>
                }
                {((!this.props.isZoomOut && isDesktopView(this.props.orientation) && !isHideScreen) || isMobileView(this.props.orientation)) &&
                    <div id="screenShareZoomButtons" className="zoomButtons" style={{ display: this.state.isConfirming ? "none" : "flex" }}>
                      <img
                        src={isMobileView(this.props.orientation) ? ic_plus_dark : ic_plus}
                        className="mr-2 zoomBtn"
                        onClick={() => this.shareFrameTransform(ZOOM.PLUS)}
                        title={getMessage("ZOOMIN")}
                      />
                      <img
                        src={isMobileView(this.props.orientation) ? ic_minus_dark : ic_minus}
                        className="zoomBtn"
                        onClick={() => this.shareFrameTransform(ZOOM.MINUS)}
                        title={getMessage("ZOOMOUT")}
                      />
                    </div>
                }
                { //Full Screen Icon
                  !this.state.isConfirming && this.props.currentParticipantUniqueId != this.props.screenSharingParticipantId &&
                  !this.props.isFullScreenV2 && screenfull.isEnabled && ((!this.props.isZoomOut && isDesktopView(this.props.orientation)) || isMobileView(this.props.orientation)) && (
                    <div className="fullScreenIcon">
                      <CardImg
                        src={isMobileView(this.props.orientation) ? ic_fullscreen_sp : ic_fullscreen_pc}
                        title={getMessage("SCREEN_ZOOMIN")}
                        className={this.state.streaming
                          ? "iconToggle cursorPointer"
                          : "iconToggle cursorPointer disabledIconOpacity cursorDisabled"}
                        onClick={() => this.state.streaming &&
                          this.toggleScreenZoomin()}
                      />
                    </div>
                  )
                }
                {!this.state.isConfirming &&
                    this.props.userRole === USER_ROLES.AGENT &&
                    this.props.screenSharingParticipantId !== this.props.uniqueId &&
                    !this.props.isZoomOut &&
                    this.props.isScreenShareDownloadAllowed &&
                    <a id="screenShareDownload">
                      <CardImg
                        src={ic_screenshare_download}
                        title={getMessage("DOWNLOAD")}
                        className="iconToggle cursorPointer"
                        onClick={this.download}
                      />
                    </a>
                }
                {!this.state.isConfirming &&
                  window._env_.REACT_APP_SHOW_BITRATE == "true" &&
                  !isIE && !this.props.isFullScreenV2 &&
                  this.state.showBitRate &&
                  <BitRateTile
                    module={Modules.SCREENSHARE}
                    mediaType={mediaType.VIDEO}
                    participantUniqueID={this.props.screenSharingParticipantId}
                    uniqueId={this.props.uniqueId}
                    wsocketPeer={wsocket.screenShareRtcPeer}
                    hide={this.props.isZoomOut && true}
                  />
                }
              </div>}
            </div>
          }
          {/** Safari has limitation that getDisplayMedia can only be called on some user gesture
           * hence this button has been displayed on safari
           */}
          {this.state.showButton ? (
            <div className="perfectCenter">
              <Button
                className="sendBtn startScreenShareBtn"
                onClick={() => {
                  this.invokeGetDisplayMedia();
                  this.setState({ showButton: false }, () => {
                    this.toggleScreenSharingLayout(false);
                    let mediaElement = document.getElementById(this.props.screenShareId);
                    mediaElement.oncanplay = () => {
                      this.setState({
                        streaming: true
                      });
                    }
                    this.setShareFrameDimensions();
                  });
                }}
              >
                {getMessage("SELECT_SCREEN_SHARE")}
              </Button>
            </div>
          ) : (
            <div className={this.props.screenSharingParticipantId === this.props.currentParticipantUniqueId &&
              !this.props.isViewScreenShare ? "fullScreenDivOffView" : "fullScreenDiv"} id={"fullScreenDiv" + this.getIdSuffix()} ref={this.screenShareElement}>
              {
                this.props.isScreenMasking && (this.props.presenterId === this.props.uniqueId) ? (
                  <div className="presenterMsgDiv">
                    <span className="presenterMsg">
                      {getMessage("YOUR_SCREEN_MASKED")}
                    </span>
                  </div>
                ) : null
              }
              {
                showMaskDiv &&
                <ScreenMaskingContainer
                  presenterId={this.props.presenterId}
                  uniqueId={this.props.uniqueId}
                />
              }
              <video
                id={this.props.screenShareId}
                className={!this.props.isZoomOut && !this.state.isFullScreen && !this.props.isFullScreenV2 ? "screenShareVideoZoomIn" : "screenShareVideo"}
                muted={true}
                autoPlay
                playsInline
                disablePictureInPicture
              />
              {this.props.currentParticipantUniqueId != this.props.screenSharingParticipantId &&
                this.state.isFullScreen &&
                <img
                  src={ic_minimize}
                  style={{filter: 'invert(1)'}} // Temporary measures
                  title={getMessage("SCREEN_ZOOMOUT")}
                  className={this.state.streaming
                    ? "iconToggle cursorPointer positionIconsFullscreen"
                    : "iconToggle cursorPointer positionIconsFullscreen disabledIconOpacity cursorDisabled"}
                  onClick={() => this.state.streaming &&
                    this.toggleScreenZoomout()}
                />
              }
              {this.state.isOverflow && isMobileView(this.props.orientation) && getDeviceOS() === "Android" && 
                <ScrollBar target={this.screenShareElement.current} />
              }
            </div>
          )}
          {isHideScreen && (
            <div className="perfectCenter">
              <div className="screenShareMsg">
                {getMessage("SCREEN_BEING_SHARED")}
              </div>
            </div>
          )}
        </Card>
      </div>
    );
  }
}
